import React from 'react'
// context
import { ObjectiveContext } from 'context/index'
// graphql
import { PLAN_OBJECTIVE_ACTIVITIES_LIST_QUERY } from 'graphql/planObjectives/queries'
// types
import { LogEntityTypes } from 'types/graphql'
// view components
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'

const ObjectiveActivitiesList: React.FC = () => {
  const { entity } = React.useContext(ObjectiveContext) as any

  const { objectiveDeleteResource, objectiveModifyResource } = entity.currentPermissions

  return (
    <ActivitiesListContainer
      canDeleteResource={objectiveDeleteResource}
      canModifyResource={objectiveModifyResource}
      entity={{ ...entity, entityType: LogEntityTypes.Objective }}
      query={PLAN_OBJECTIVE_ACTIVITIES_LIST_QUERY}
      variables={{
        filter: {
          entityId: entity.id,
          actionType: ['CREATE', 'UPDATE', 'DELETE'],
          entityType: ['IMAGE', 'LINK', 'COMMENT', 'RESOURCE']
        }
      }}
    />
  )
}

export default ObjectiveActivitiesList
